export default __webpack_public_path__ + "static/media/facuserif.ed108731.jpg";